<template>
  <div class="AnnouncementContentTextHeadline">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AnnouncementContentTextHeadline',
  props: {
    variant: {
      type: String,
      default: 'purple',
      validator(value) {
        return ['purple', 'green', 'orange'].includes(value)
      },
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss">
.AnnouncementContentTextHeadline {
  @include headlineDefaultValues();
  font-size: 16px;
  letter-spacing: -0.5px;
  line-height: 1;
  background: $color-gradient-primary;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  &.purple {
    background: $color-gradient-primary;
  }

  &.green {
    background: linear-gradient(90deg, #007644 0%, #4ed653 100%);
  }

  &.orange {
    background: linear-gradient(90deg, #ff6e3f 0%, #fe9726 100%);
  }
}
</style>
